import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { ReferrerGraphBinaryMapResponse, ReferrerGraphPersonalGroupListResponse, ReferrerGraphUniLevelListResponse } from 'api/common/responses'
import { PositionNumberType } from './common/constants'

/**
 * 紹介者管理バイナリーマップAPI
 * @param positionNumber
 * @param targetPositionId
 * @param callback
 */
export const referrerGraphBinaryMapAPI = async (positionNumber: PositionNumberType, targetPositionId: number, callback: (response?: ReferrerGraphBinaryMapResponse) => void) => {
  await apiClient.get(`/referrerGraph/binaryMap/${positionNumber}/${targetPositionId}`).then((response: AxiosResponse<ReferrerGraphBinaryMapResponse>) => {
    const apiResult = response?.data
    callback(apiResult)
  })
}

/**
 * 紹介者管理ユニレベルリストAPI
 * @param positionNumber
 * @param positionId
 * @param pagination
 * @param callback
 */
export const referrerGraphUniLevelListAPI = async (
  positionNumber: PositionNumberType,
  positionId: number,
  pagination: number,
  callback: (response?: ReferrerGraphUniLevelListResponse) => void,
) => {
  await apiClient.get(`/referrerGraph/uniLevelList/${positionNumber}/${positionId}/${pagination}`).then((response: AxiosResponse<ReferrerGraphUniLevelListResponse>) => {
    const apiResult = response?.data
    callback(apiResult)
  })
}

/**
 * 紹介者管理パーソナルグループリストAPI
 * @param positionNumber
 * @param atemQuestId
 * @param pagination
 * @param callback
 */
export const referrerGraphPersonalGroupListAPI = async (
  positionNumber: PositionNumberType,
  atemQuestId: string,
  pagination: number,
  callback: (response?: ReferrerGraphPersonalGroupListResponse) => void,
) => {
  await apiClient.get(`/referrerGraph/personalGroupList/${positionNumber}/${atemQuestId}/${pagination}`).then((response: AxiosResponse<ReferrerGraphPersonalGroupListResponse>) => {
    const apiResult = response?.data
    callback(apiResult)
  })
}
